import { all, takeLatest, put, fork, call } from 'redux-saga/effects';
import actions from './actions';
import * as multipleChoiceSingleAnswerServices from '@iso/services/listening/multipleChoiceSingleAnswer';

//#region CRUD
export function* getMultipleChoiceSingleAnswer() {
	yield takeLatest(actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER, function* ({ payload }) {
		const { model } = payload;
		try {
			var response = yield call(multipleChoiceSingleAnswerServices.getMultipleChoiceSingleAnswer, model);
			if (response.data.success === true) {
				var data = response.data.data.data;
				var totalItems = response.data.data.total;
				yield put({
					type: actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER_SUCCESS,
					payload: { data, totalItems },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* getMultipleChoiceSingleAnswerDetail() {
	yield takeLatest(actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL, function* ({ payload }) {
		const { id } = payload;
		try {
			var response = yield call(multipleChoiceSingleAnswerServices.getMultipleChoiceSingleAnswerDetail, id);
			if (response.data.success === true) {
				var data = response.data.data;
				yield put({
					type: actions.GET_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL_SUCCESS,
					payload: { data },
				});
			}
		} catch (e) {
			yield put({
				type: actions.LISTENING_LOADING_FALSE,
			});
		}
	});
}

export function* createQuesMultipleChoiceSingleAnswer() {
	yield takeLatest(actions.CREATE_NEW_QUESTION_MULTIPLE_CHOICE_SINGLE_ANSWER, function* ({ payload, cbSuccess, cbError }) {
		const { body } = payload;
		try {
			var response = yield call(multipleChoiceSingleAnswerServices.createQuesMultipleChoiceSingleAnswer, body);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* updateMultipleChoiceSingleAnswerDetail() {
	yield takeLatest(actions.UPDATE_MULTIPLE_CHOICE_SINGLE_ANSWER_DETAIL, function* ({ payload, cbSuccess, cbError }) {
		const { model } = payload;
		try {
			var response = yield call(multipleChoiceSingleAnswerServices.updateMultipleChoiceSingleAnswerDetail, model);
			if (response.data.success === true) {
				yield cbSuccess();
			} else if (response?.data?.message === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			}
		} catch (e) {
				if (e?.response?.data?.ErrorMessage && e?.response?.data?.ErrorMessage === 'ORDER_IN_SET_CANNOT_BE_DUPLICATED') {
				yield cbError('Trùng thứ tự');
			} else {
				yield cbError(e.response.data.ErrorMessage);
			};
		}
	});
}

export function* deleteMultipleChoiceSingleAnswer() {
	yield takeLatest(actions.DELETE_MULTIPLE_CHOICE_SINGLE_ANSWER, function* ({ payload, cbSuccess, cbError }) {
		const { id } = payload;
		try {
			var response = yield call(multipleChoiceSingleAnswerServices.deleteMultipleChoiceSingleAnswer, id);
			if (response.data.success === true) {
				yield cbSuccess();
			}
		} catch (e) {
			if (e.response && e.response.data) yield cbError(e.response.data.ErrorMessage);
			else yield cbError();
		}
	});
}

export default function* rootSaga() {
	yield all([
		fork(getMultipleChoiceSingleAnswer),
		fork(getMultipleChoiceSingleAnswerDetail),
		fork(createQuesMultipleChoiceSingleAnswer),
		fork(updateMultipleChoiceSingleAnswerDetail),
		fork(deleteMultipleChoiceSingleAnswer),
	]);
}
